import { ApiResult, CrudService } from 'ui-shared';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ProdutoAnexoEntity } from '@catalogo/models/produto-anexo.entity';
import { Observable } from "rxjs";
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'root' })
export class ProdutoAnexoDataService extends CrudService<ProdutoAnexoEntity> {
    protected url: string;
    urlOriginal: string;

    constructor(
        @Inject(OPERACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.urlOriginal = `${urlBase}/v1/Produto/<id>/Anexos`;
    }

    public withParentId(parentId: string) {
        this.url = this.urlOriginal.replace('<id>', parentId);
        return this;
    }

    public downloadById = (id: string): Observable<HttpResponse<Blob>> => {
        return this.httpClient.get(this.apiUrlWithId(id), {observe: 'response', responseType: 'blob'});
    }

}
